/* Mauna - fechas reales en la linea de entrega, y alt en las
   miniaturas de "You looked at these". Sin dependencias. */
(function () {
  'use strict';

  /* [data-mna-range="4,8"] se convierte en "Sep 4-8", contado desde
     el dia en que se abre la pagina. Se escribe en el navegador para
     que las fechas nunca queden viejas ni mal cacheadas.

     Las opciones de variante con un solo valor se ocultan por CSS,
     no aqui: Horizon las marca con data-testid="variant-option-single". */

  function addDays(days) {
    var d = new Date();
    d.setDate(d.getDate() + days);
    return d;
  }

  function month(d) {
    return d.toLocaleDateString('en-US', { month: 'short' });
  }

  function fillDates() {
    var slots = document.querySelectorAll('[data-mna-range]');
    if (!slots.length) return;

    Array.prototype.forEach.call(slots, function (slot) {
      if (slot.getAttribute('data-mna-filled')) return;

      var parts = slot.getAttribute('data-mna-range').split(',');
      var from = addDays(Number(parts[0]));
      var to = addDays(Number(parts[1]));
      var text;

      if (from.getMonth() === to.getMonth()) {
        text = month(from) + ' ' + from.getDate() + '–' + to.getDate();
      } else {
        text = month(from) + ' ' + from.getDate() + ' – ' + month(to) + ' ' + to.getDate();
      }

      slot.textContent = text;
      slot.setAttribute('data-mna-filled', '1');
    });
  }

  /* Las miniaturas de "You looked at these" se construyen en el
     navegador, asi que salian sin alt. Se lo copiamos del titulo
     que ya esta al lado. */
  function fillAlts() {
    var items = document.querySelectorAll('.mnrv-item');
    if (!items.length) return;

    Array.prototype.forEach.call(items, function (item) {
      var img = item.querySelector('img');
      if (!img || (img.getAttribute('alt') || '').trim()) return;
      var title = item.querySelector('.mnrv-t');
      if (!title) return;
      img.setAttribute('alt', title.textContent.trim());
    });
  }

  function run() {
    fillDates();
    fillAlts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      run();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
